(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5731],{

/***/ 64678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch/[webinarId]",
      function () {
        return __webpack_require__(30087);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _webinarId_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/router.js
var router = __webpack_require__(43771);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@11.3.0_22i2vm6kkdnjds7qamf3bqxxhi/node_modules/next-i18next/dist/esm/index.js + 21 modules
var esm = __webpack_require__(25941);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-query/es/index.js
var es = __webpack_require__(1759);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Spinner/index.tsx
var Spinner = __webpack_require__(11764);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/contexts/OnAir.tsx
var contexts_OnAir = __webpack_require__(60697);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/analytics/index.ts + 8 modules
var analytics = __webpack_require__(62430);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/constants/featureFlags.ts
var featureFlags = __webpack_require__(78289);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/constants.ts
var constants = __webpack_require__(31777);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/scenes/Watch/index.tsx + 12 modules
var Watch = __webpack_require__(37450);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/scenes/PreScreen/index.tsx + 1 modules
var PreScreen = __webpack_require__(70614);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/scenes/EmbedPreScreen/index.tsx + 3 modules
var EmbedPreScreen = __webpack_require__(32550);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/scenes/EmbedWatch/index.tsx + 9 modules
var EmbedWatch = __webpack_require__(73692);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/scenes/PreScreenV2/index.tsx + 30 modules
var PreScreenV2 = __webpack_require__(58884);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/styles.ts
var styles = __webpack_require__(28253);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/OnAir/OnAirPageDisplay.tsx












var _obj;
var ON_AIR_DISPLAY = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ON_AIR_VIEWER_PAGE.EMBED_PRESCREEN */.hx.EMBED_PRESCREEN, EmbedPreScreen/* default */.Z), (0,_define_property/* default */.Z)(_obj, constants/* ON_AIR_VIEWER_PAGE.EMBED_WATCH */.hx.EMBED_WATCH, EmbedWatch/* default */.Z), (0,_define_property/* default */.Z)(_obj, constants/* ON_AIR_VIEWER_PAGE.PRESCREEN */.hx.PRESCREEN, PreScreen/* default */.Z), (0,_define_property/* default */.Z)(_obj, constants/* ON_AIR_VIEWER_PAGE.WATCH */.hx.WATCH, Watch/* default */.Z), _obj);
var _obj1;
var DISPLAY_EVENT = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, constants/* ON_AIR_VIEWER_PAGE.EMBED_PRESCREEN */.hx.EMBED_PRESCREEN, analytics/* default.events.ON_AIR_WEBINAR_EMBED_PRESCREEN_PAGE_VISITED */.ZP.events.ON_AIR_WEBINAR_EMBED_PRESCREEN_PAGE_VISITED), (0,_define_property/* default */.Z)(_obj1, constants/* ON_AIR_VIEWER_PAGE.PRESCREEN */.hx.PRESCREEN, analytics/* default.events.ON_AIR_WEBINAR_PRE_SCREEN_PAGE_VISITED */.ZP.events.ON_AIR_WEBINAR_PRE_SCREEN_PAGE_VISITED), (0,_define_property/* default */.Z)(_obj1, constants/* ON_AIR_VIEWER_PAGE.EMBED_WATCH */.hx.EMBED_WATCH, analytics/* default.events.ON_AIR_WEBINAR_EMBED_WATCH_PAGE_VISITED */.ZP.events.ON_AIR_WEBINAR_EMBED_WATCH_PAGE_VISITED), (0,_define_property/* default */.Z)(_obj1, constants/* ON_AIR_VIEWER_PAGE.WATCH */.hx.WATCH, analytics/* default.events.ON_AIR_WEBINAR_WATCH_PAGE_VISITED */.ZP.events.ON_AIR_WEBINAR_WATCH_PAGE_VISITED), _obj1);
var getDisplay = function getDisplay(page) {
    if ((page === constants/* ON_AIR_VIEWER_PAGE.PRESCREEN */.hx.PRESCREEN || page === constants/* ON_AIR_VIEWER_PAGE.EMBED_PRESCREEN */.hx.EMBED_PRESCREEN) && featureFlags/* default.onAirRegistrationRedesign */.ZP.onAirRegistrationRedesign) {
        return PreScreenV2/* default */.Z;
    }
    return ON_AIR_DISPLAY[page];
};
var OnAirPageDisplay = function OnAirPageDisplay(param) {
    var page = param.page, webinar = param.webinar;
    var DisplayComponent = getDisplay(page);
    var isRegistrationEnabled = webinar.isRegistrationEnabled, isUserRegistered = webinar.isUserRegistered, status = webinar.status;
    (0,react.useEffect)(function() {
        if (!DISPLAY_EVENT[page]) {
            return;
        }
        analytics/* default.track */.ZP.track(DISPLAY_EVENT[page], {
            isRegistrationEnabled: isRegistrationEnabled,
            isUserRegistered: isUserRegistered,
            status: status
        });
    }, [
        isRegistrationEnabled,
        isUserRegistered,
        page,
        status
    ]);
    (0,react.useEffect)(function() {
        if (!isRegistrationEnabled && status === constants/* ON_AIR_STATUS.CREATED */.uI.CREATED) {
            analytics/* default.track */.ZP.track(analytics/* default.events.ON_AIR_WEBINAR_REGISTRATION_OFF_PAGE_VISITED */.ZP.events.ON_AIR_WEBINAR_REGISTRATION_OFF_PAGE_VISITED);
        }
    }, [
        isRegistrationEnabled,
        status
    ]);
    if (page === constants/* ON_AIR_VIEWER_PAGE.WATCH */.hx.WATCH) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayComponent, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Layout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayComponent, {})
    });
};
/* harmony default export */ var OnAir_OnAirPageDisplay = (OnAirPageDisplay);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.3/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(25862);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/utils/hooks/index.ts + 1 modules
var hooks = __webpack_require__(1964);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/api/index.ts + 8 modules
var api = __webpack_require__(8318);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/contexts/Session.tsx + 1 modules
var Session = __webpack_require__(28762);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/services/logger/index.ts + 6 modules
var logger = __webpack_require__(86149);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/OnAir/hooks/useWebsocket.ts





// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
var CLOSE_NORMAL_STATUS_CODE = 1000;
var randomIntFromInterval = function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
var useWebsocket = function useWebsocket(_param) {
    var url = _param.url, enabled = _param.enabled, isViewerCountEnabled = _param.isViewerCountEnabled, sessionRegistrationId = _param.sessionRegistrationId, heartbeatData = _param.heartbeatData, cb = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "enabled",
        "isViewerCountEnabled",
        "sessionRegistrationId",
        "heartbeatData"
    ]);
    var socketRef = (0,react.useRef)(null);
    var optionsCache = (0,react.useRef)(cb);
    optionsCache.current = cb;
    var activeSubscribers = (0,react.useRef)({
        VIEWERS_COUNT_CHANNEL: false,
        WEBINAR_STATUS_CHANNEL: false,
        WEBINAR_INVITATION_CHANNEL: false
    });
    var subscribeToEvent = (0,react.useCallback)(function(channel) {
        if (socketRef.current && !activeSubscribers.current[channel]) {
            socketRef.current.send(constants/* ON_AIR_SUBSCRIBE */.$i[channel]);
            activeSubscribers.current[channel] = true;
        }
    }, [
        activeSubscribers
    ]);
    var unsubscribeFromEvent = (0,react.useCallback)(function(channel) {
        if (socketRef.current && activeSubscribers.current[channel]) {
            socketRef.current.send(constants/* ON_AIR_SUBSCRIBE */.$i["".concat(channel, "_UNSUBSCRIBE")]);
            activeSubscribers.current[channel] = false;
        }
    }, [
        activeSubscribers
    ]);
    var deactivateAllSubscribers = (0,react.useCallback)(function() {
        Object.keys(activeSubscribers.current).forEach(function(channel) {
            if (activeSubscribers.current[channel]) {
                activeSubscribers.current[channel] = false;
            }
        });
    }, [
        activeSubscribers
    ]);
    (0,react.useEffect)(function() {
        var action = isViewerCountEnabled ? subscribeToEvent : unsubscribeFromEvent;
        action("VIEWERS_COUNT_CHANNEL");
    }, [
        isViewerCountEnabled,
        subscribeToEvent,
        unsubscribeFromEvent
    ]);
    (0,react.useEffect)(function() {
        var retryWithBackoffStrategy = function retryWithBackoffStrategy(fn, param) {
            var _retryCount = param.retryCount, retryCount = _retryCount === void 0 ? 1 : _retryCount, retryReason = param.retryReason;
            var retryTimeout = Math.min(constants/* ON_AIR_SUBSCRIBE.MAXIMUM_BACKOFF_MILLISECONDS */.$i.MAXIMUM_BACKOFF_MILLISECONDS, Math.pow(2, retryCount) * 1000);
            logger/* default.info */.ZP.info("watchPage::Connection closed, retrying...", (0,_object_spread/* default */.Z)({
                retryTimeout: retryTimeout
            }, retryReason));
            socketRef.current = null;
            // fn();
            setTimeout(fn, retryTimeout);
        };
        var connect = function() {
            var retryIteration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var retryCount = retryIteration || 0;
            var heartbeatIntervalId;
            var socket = new WebSocket(url);
            socketRef.current = socket;
            socket.onopen = function() {
                var _current, ref;
                (ref = (_current = optionsCache.current).onOpen) === null || ref === void 0 ? void 0 : ref.call(_current, socket);
                if (isViewerCountEnabled) {
                    subscribeToEvent("VIEWERS_COUNT_CHANNEL");
                }
                subscribeToEvent("WEBINAR_STATUS_CHANNEL");
                subscribeToEvent("WEBINAR_INVITATION_CHANNEL");
                if (heartbeatIntervalId) {
                    clearInterval(heartbeatIntervalId);
                }
                heartbeatIntervalId = setInterval(function() {
                    // Send heartbeat every 15 to 25 seconds
                    socket.send(constants/* ON_AIR_SUBSCRIBE.HEARTBEAT_COMMAND */.$i.HEARTBEAT_COMMAND(heartbeatData));
                }, randomIntFromInterval(15000, 25000));
                retryCount = 0;
            };
            socket.onmessage = function(event) {
                if (event && event.data) {
                    var _current, ref;
                    (ref = (_current = optionsCache.current).onMessage) === null || ref === void 0 ? void 0 : ref.call(_current, JSON.parse(event.data));
                }
            };
            socket.onclose = function(param) {
                var code = param.code, reason = param.reason, wasClean = param.wasClean;
                var _current, ref;
                (ref = (_current = optionsCache.current).onClose) === null || ref === void 0 ? void 0 : ref.call(_current, code);
                deactivateAllSubscribers();
                if (enabled && code !== CLOSE_NORMAL_STATUS_CODE) {
                    if (heartbeatIntervalId) {
                        clearInterval(heartbeatIntervalId);
                    }
                    retryWithBackoffStrategy(function() {
                        return connect(retryCount + 1);
                    }, {
                        retryCount: retryCount,
                        retryReason: {
                            code: code,
                            reason: reason,
                            wasClean: wasClean
                        }
                    });
                } else {
                    clearInterval(heartbeatIntervalId);
                }
            };
            socket.onerror = function(err) {
                deactivateAllSubscribers();
                if (heartbeatIntervalId) {
                    clearInterval(heartbeatIntervalId);
                }
                if (enabled) {
                    var _current, ref;
                    (ref = (_current = optionsCache.current).onError) === null || ref === void 0 ? void 0 : ref.call(_current, err);
                    // Log error only every 6th attempt to reduce noise
                    if (retryCount % 6 === 0) {
                        var error = (0,logger/* castUnknownToError */.uI)(err);
                        logger/* default.captureException */.ZP.captureException({
                            error: error,
                            message: "watchPage::Connection error. Cannot fetch webinar status",
                            tags: {
                                onair: true
                            }
                        });
                    }
                }
            };
        };
        if (enabled) {
            connect();
        }
        return function() {
            var ref;
            (ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.close(CLOSE_NORMAL_STATUS_CODE);
        };
    }, [
        enabled,
        url
    ]); // eslint-disable-line
    var getSocket = (0,react.useCallback)(function() {
        return socketRef.current;
    }, []);
    return {
        getSocket: getSocket
    };
};
/* harmony default export */ var hooks_useWebsocket = (useWebsocket);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/hooks/useOnAirPaths.ts
var useOnAirPaths = __webpack_require__(23850);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/OnAir/hooks/useWebinar/index.ts









var getRefreshIntervalTime = function getRefreshIntervalTime(param) {
    var isUserRegistered = param.isUserRegistered, shouldUseWebsocket = param.shouldUseWebsocket, isWSConnected = param.isWSConnected;
    if (isUserRegistered) {
        if (shouldUseWebsocket) {
            return isWSConnected ? 60000 : 15000;
        }
        return 60000;
    }
    return 0;
};
var useWebinar = function useWebinar(param) {
    var onMessage = param.onMessage, isViewerCountEnabled = param.isViewerCountEnabled, shouldUseWebsocket = param.shouldUseWebsocket, webinarId = param.webinarId;
    var ref = (0,Session/* useSession */.kP)(), query = ref.query, requestOptions = ref.requestOptions, sessionRegistrationId = ref.sessionRegistrationId;
    var subscribeWs = (0,useOnAirPaths/* useOnAirPaths */.j)().subscribeWs;
    var ref1 = (0,react.useState)(false), isWSConnected = ref1[0], setIsWsConnected = ref1[1];
    var isMounted = (0,hooks/* useMountedState */.DJ)();
    var websocketHeartbeatData = (0,react.useRef)({
        streamId: undefined
    });
    var getSocket = hooks_useWebsocket({
        enabled: shouldUseWebsocket,
        isViewerCountEnabled: isViewerCountEnabled,
        sessionRegistrationId: sessionRegistrationId,
        url: "".concat(subscribeWs, "/").concat(webinarId, "/status").concat(query),
        heartbeatData: websocketHeartbeatData.current,
        onMessage: function onMessage1(data) {
            onMessage(data);
        },
        onOpen: function onOpen() {
            if (isMounted()) {
                setIsWsConnected(true);
            }
        },
        onClose: function onClose() {
            if (isMounted()) {
                setIsWsConnected(false);
            }
        }
    }).getSocket;
    var refetch = (0,es.useQuery)({
        queryKey: [
            "webinar",
            webinarId
        ],
        queryFn: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    (0,api/* getWebinar */.tz)({
                        id: webinarId
                    }, requestOptions)
                ];
            });
        }),
        refetchIntervalInBackground: true,
        refetchInterval: function refetchInterval(data) {
            return getRefreshIntervalTime({
                isWSConnected: isWSConnected,
                shouldUseWebsocket: shouldUseWebsocket,
                isUserRegistered: data === null || data === void 0 ? void 0 : data.isUserRegistered
            });
        },
        onSuccess: function onSuccess(data) {
            onMessage(data);
            // Update the our websocket heartbeat data with the current stream ID
            websocketHeartbeatData.current.streamId = data.streamId;
        }
    }).refetch;
    return {
        getSocket: getSocket,
        refetch: refetch
    };
};
/* harmony default export */ var hooks_useWebinar = (useWebinar);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/scenes/OnAir/utils/index.ts + 1 modules
var utils = __webpack_require__(21);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/OnAir/OnAir.tsx









var OnAir = function OnAir(param) {
    var isEmbedded = param.isEmbedded, webinarId = param.webinarId;
    var ref = (0,react.useState)(), webinar = ref[0], setWebinar = ref[1];
    var ref1 = (0,react.useState)(), invitation = ref1[0], setInvitation = ref1[1];
    // compute on update so time paddings are consistent throughout the app
    var ref2 = (0,utils/* getTimePaddings */.aY)(webinar), isStartingSoon = ref2.isStartingSoon, hasFinishedRecently = ref2.hasFinishedRecently;
    var page = (0,utils/* getPage */.fx)({
        isStartingSoon: isStartingSoon,
        isEmbedded: isEmbedded,
        webinar: webinar
    });
    var shouldUseWebsocket = (0,utils/* getShouldUseWebsocket */.uM)({
        hasFinishedRecently: hasFinishedRecently,
        isStartingSoon: isStartingSoon,
        page: page,
        webinar: webinar
    });
    var onMessage = function onMessage(data) {
        if (!data) return;
        if ("type" in data && data.type === "invitation") {
            var type = data.type, rest = (0,_object_without_properties/* default */.Z)(data, [
                "type"
            ]);
            setInvitation(rest);
            return;
        }
        setWebinar(function(existing) {
            return (0,_object_spread/* default */.Z)({}, existing || {}, data);
        });
    };
    var ref3;
    var ref4 = hooks_useWebinar({
        onMessage: onMessage,
        isViewerCountEnabled: (ref3 = webinar === null || webinar === void 0 ? void 0 : webinar.isViewerCountEnabled) !== null && ref3 !== void 0 ? ref3 : true,
        shouldUseWebsocket: shouldUseWebsocket,
        webinarId: webinarId
    }), refetchWebinar = ref4.refetch, getSubscribeSocket = ref4.getSocket;
    if (!webinar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                id: "onair-loading-".concat(webinarId)
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts_OnAir/* default */.ZP, {
        isEmbedded: isEmbedded,
        webinar: webinar,
        invitation: invitation,
        refetchWebinar: refetchWebinar,
        getSubscribeSocket: getSubscribeSocket,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnAir_OnAirPageDisplay, {
            page: page,
            webinar: webinar
        })
    });
};
/* harmony default export */ var OnAir_OnAir = (OnAir);

;// CONCATENATED MODULE: ./workspaces/app/static/main/src/scenes/OnAir/index.tsx





var queryClient = new es.QueryClient();
var OnAirPage = function OnAirPage(param) {
    var isEmbedded = param.isEmbedded, jwt = param.jwt, sessionRegistrationId = param.sessionRegistrationId, webinarId = param.webinarId, sessionCountryCode = param.sessionCountryCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Session/* default */.ZP, {
            isEmbedded: isEmbedded,
            jwt: jwt,
            sessionRegistrationId: sessionRegistrationId,
            sessionCountryCode: sessionCountryCode,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnAir_OnAir, {
                isEmbedded: isEmbedded,
                webinarId: webinarId
            })
        })
    });
};
/* harmony default export */ var scenes_OnAir = (OnAirPage);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/ssrWrapper.js
var ssrWrapper = __webpack_require__(43905);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/pages/OnAirPage.js
/* eslint-disable react/prop-types */ 






var removeQueryParam = function removeQueryParam(router, param) {
    var pathname = router.pathname, query = router.query;
    var params = new URLSearchParams(query);
    params.delete(param);
    router.replace({
        pathname: pathname,
        query: params.toString()
    }, undefined, {
        shallow: true
    });
};
var OnAirPage_OnAirPage = function OnAirPage(_param) {
    var i18n = _param.i18n, router = _param.router, props = (0,_object_without_properties/* default */.Z)(_param, [
        "i18n",
        "router"
    ]);
    (0,react.useEffect)(function() {
        if (router.isReady && router.query.token) {
            removeQueryParam(router, "token");
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        i18n: i18n
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scenes_OnAir, (0,_object_spread/* default */.Z)({}, props))
    }));
};
/* harmony default export */ var pages_OnAirPage = (OnAirPage_OnAirPage);

;// CONCATENATED MODULE: ./src/pages/watch/[webinarId]/index.tsx




var _webinarId_OnAir = function(param) {
    var isEmbedded = param.isEmbedded, jwt = param.jwt, sessionRegistrationId = param.sessionRegistrationId, webinarId = param.webinarId, sessionCountryCode = param.sessionCountryCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_OnAirPage, {
        i18n: esm/* i18n */.ag,
        router: (0,router.useRouter)(),
        isEmbedded: isEmbedded,
        sessionRegistrationId: sessionRegistrationId,
        jwt: jwt,
        webinarId: webinarId,
        sessionCountryCode: sessionCountryCode
    });
};
var __N_SSP = true;
/* harmony default export */ var _webinarId_ = (_webinarId_OnAir);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1674,9574,9224,7021,7523,231,8869,9194,6149,3905,548,5646,1754,8908,4911,8379,9804,9774,2888,179], function() { return __webpack_exec__(64678); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);